export class APIv4CartLocalStorageAdapter {
  static mapCartProduct(product) {
    const mappedProduct = Object.assign({}, product);
    mappedProduct.formerItemQuantity = product.quantity;
    mappedProduct.id = product.productId;
    mappedProduct.info = {};
    return mappedProduct;
  }
}
